import { ActionType, createReducer } from 'typesafe-actions'

import * as Actions from './actions'
import { PartnerHotelsState } from './types'

const INITIAL_STATE: PartnerHotelsState = {
  error: '',
  list: [],
  loading: false,
  request_totals: {
    total_emissions: 0,
    total_quotations: 0
  },
  sendPartnerHotelsError: '',
  sendPartnerHotelsLoading: false,
  total_results: 0
}

const reducer = createReducer<PartnerHotelsState, ActionType<typeof Actions>>(
  INITIAL_STATE
)
  .handleAction(Actions.getPartnerHotels, state => ({
    ...state,
    error: '',
    loading: true
  }))
  .handleAction(Actions.getPartnerHotelsFailure, (state, { payload }) => ({
    ...state,
    error: payload.message,
    loading: false
  }))
  .handleAction(Actions.getPartnerHotelsSuccess, (state, { payload }) => ({
    ...state,
    list: [...payload.partner_hotels],
    loading: false
  }))
  .handleAction(Actions.sendPartnerHotel, state => ({
    ...state,
    sendPartnerHotelsError: '',
    sendPartnerHotelsLoading: true
  }))
  .handleAction(Actions.sendPartneHotelFailure, (state, { payload }) => ({
    ...state,
    sendPartnerHotelsError: payload.message,
    sendPartnerHotelsLoading: false
  }))
  .handleAction(Actions.sendPartneHotelSuccess, state => ({
    ...state,
    sendPartnerHotelsLoading: false
  }))

export default reducer
